<template>
  <div v-if="isShown" >
    <v-tooltip v-if="isSigned" bottom>
      <template v-slot:activator="{ on }">
        <i aria-hidden="true" v-on="on"
           :class="'v-icon notranslate material-icons primary--text'">draw</i>
      </template>
      <span>{{ $t('book/issue:common.signed') }}</span>
    </v-tooltip>
    <v-tooltip v-if="isProcessed" bottom>
      <template v-slot:activator="{ on }">
        <i aria-hidden="true" v-on="on"
           :class="'v-icon notranslate material-icons primary--text'">send</i>
      </template>
      <span>{{ $t('book/issue:common.processed') }}</span>
    </v-tooltip>
  </div>
  <div v-else>
    ~
  </div>
</template>
<script>
  export default {
    name: 'StatusDecorator',
    props: {
      item: {}
    },
    data() {
      return {
        signed: null,
        prossed: null
      }
    },
    computed: {
      isShown() {
        return this.isSigned || this.isProcessed;
      },
      icon() {
        return 'draw';
      },
      statusText() {
        return 'signed';
      },
      isSigned() {
        if (!this.item || !this.item.taskStatus) return  false;

        let isSigned = false;
        this.item.taskStatus.forEach(status => {
          if (status.action === 'INVOICE_SIGN' && status.objectId === this.item.id) {
            isSigned = true;
          }
        });
        return isSigned;
      },
      isProcessed() {
        if (!this.item || !this.item.taskStatus) return  false;

        let isProcessed = false;
        this.item.taskStatus.forEach(status => {
          if (status.action === 'INVOICE_SEND' && status.objectId === this.item.id) {
            isProcessed = true;
          }
        });
        return isProcessed;
      }
    }
  }
</script>